import client from "./client";

export default {

    async getPaymentAccounts(filters) {
        return client.parseResponse(await client.get('/payment-accounts', filters));
    },

    async createPaymentAccounts(data) {
        return client.parseResponse(await client.post('/payment-accounts', data))
    },

    async getPaymentAccount(id) {
        return client.parseResponse(await client.get('/payment-accounts/' + id));
    },

    async editPaymentAccount(data) {
        return client.parseResponse(await client.put('/payment-accounts/' + data.id, data))
    },

    async deletePaymentAccount(data) {
        return client.parseResponse(await client.delete('/payment-accounts/' + data.id, data))
    },

}
